import React, { useState } from 'react';
import { Button, Grid, Stack } from '@mui/material';
import { FormTextField } from '../../common/Form/FormTextField';

export default function UploadForm({ id, onUpload }) {
  const [file, setFile] = useState();

  return (
    <Stack id={`${id}__stack_wrapper`} direction={'column'} gap={2} mt={2}>
      {
        <Grid
          id={`${id}__grid_container`}
          container
          direction="column"
          spacing={2}
          sx={{
            justifyContent: 'center',
          }}
        >
          <Grid item id={`${id}__grid_item_codecsCsv`} xs={12} xl={3}>
            <FormTextField
              id={`${id}__inputFile_codecsCsv`}
              label="Codecs CSV"
              type="file"
              placeholder="Codecs CSV"
              onChange={(value) => setFile(value)}
              textAlign={{ xs: 'start' }}
              labelGridProps={{ xs: 12, md: 2 }}
              inputGridProps={{ xs: 12, md: 10 }}
            />
          </Grid>
          <Grid
            id={`${id}__grid_item_actions`}
            item
            xs={12}
            xl={12}
            sx={{ p: 0, alignSelf: 'flex-end' }}
          >
            <Button
              id={`${id}__button_upload`}
              className="myOdu__button primary"
              variant="outlined"
              sx={{ mt: 1 }}
              onClick={() => onUpload(file)}
              disabled={!file}
            >
              Upload
            </Button>
          </Grid>
        </Grid>
      }
    </Stack>
  );
}
